import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import UserSearch from "../components/UserSearch";
import InventorySearch from "../components/InventorySearch";
import LocationSearch from "../components/LocationSearch";
import PresetVoucher from "../components/PresetVoucher";
import StocktakeSearch from "../components/StocktakeSearch";
import RoleSearch from "../components/RoleSearch";
import Merchandise from "../components/Merchandise";
import DeploymentSearch from "../components/DeploymentSearch";
import ModelSearch from "../components/ModelSearch";
import AddColorPage from "../components/AddColorPage";
import PartnerSearch from "../components/PartnerSearch"; 
import "../styles.css";
import "../components/InventorySearch.css";

function AdminDashboard() {
  const [view, setView] = useState("inventory");
  const { hash } = useParams(); // Extract hash from URL

  const renderContent = () => {
    switch (view) {
      case "users":
        return <UserSearch />;
      case "inventory":
        return <InventorySearch />;
      case "Locations":
        return <LocationSearch />;
      case "merchandise":
        return <Merchandise />;       
      case "Stocktake":
        return <StocktakeSearch />;
      case "AccessRole":
        return <RoleSearch />;
      case "Deployment":
        return <DeploymentSearch />;
      case "Model":
        return <ModelSearch />;
      case "Add colour":
        return <AddColorPage />;
      case "Add partner":           
        return <PartnerSearch />;
      default:
        return <InventorySearch />;
    }
  };

  return (
    <div className="admin-dashboard">
      <Sidebar onSelect={setView} hash={hash} />
      <div className="dashboard-content">{renderContent()}</div>
    </div>
  );
}

export default AdminDashboard;